import ConstructionIcon from '@mui/icons-material/Construction'
import FlatwareIcon from '@mui/icons-material/Flatware'
import HotelIcon from '@mui/icons-material/Hotel'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import ScaleIcon from '@mui/icons-material/Scale'
import {
  IndustryCategoryEnum,
  IndustryFoodTypeEnum,
} from '@ulysses-inc/harami_api_client'
import type { FunctionComponent, SVGProps } from 'react'
import AddFileSvg from 'src/assets/icons/addfile.svg?react'
import type { IndustryInfo } from 'src/features/templateEdit/onboarding/types'
import { IndustryNames } from './constants'

export const DefaultIndustries: IndustryInfo[][] = [[]]

export const IndustryGroups: IndustryInfo[][] = [
  [
    {
      svgComponent: AddFileSvg,
      title: '空のひな形',
      type: IndustryFoodTypeEnum.EMPTY,
    },
    {
      svgComponent: FlatwareIcon as FunctionComponent<SVGProps<SVGSVGElement>>,
      title: IndustryNames.FOOD,
      type: IndustryCategoryEnum.FOOD,
    },
    {
      svgComponent: ScaleIcon as FunctionComponent<SVGProps<SVGSVGElement>>,
      title: IndustryNames.MANUFACTURE,
      type: IndustryCategoryEnum.MANUFACTURE,
    },
    {
      svgComponent: HotelIcon as FunctionComponent<SVGProps<SVGSVGElement>>,
      title: IndustryNames.HOTEL,
      type: IndustryCategoryEnum.HOTEL,
    },
    {
      svgComponent: LocalShippingIcon as FunctionComponent<
        SVGProps<SVGSVGElement>
      >,
      title: IndustryNames.LOGISTICS,
      type: IndustryCategoryEnum.LOGISTICS,
    },
    {
      svgComponent: ConstructionIcon as FunctionComponent<
        SVGProps<SVGSVGElement>
      >,
      title: IndustryNames.MACHINE,
      type: IndustryCategoryEnum.MACHINE,
    },
    {
      svgComponent: MoreHorizIcon as FunctionComponent<SVGProps<SVGSVGElement>>,
      title: IndustryNames.OTHER,
      type: IndustryCategoryEnum.OTHER,
    },
  ],
]
